// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"61":"fbfe8a20546efeae","749":"702b7d485c77a81a","821":"87b492c0f81d54e3","825":"8be44dc2e93dafa4","993":"9b0a1d642dc76ca3"}[chunkId] + ".js";
};